<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="6" class="px-4 mt-n3">
        <v-row dark align="end">
          <div class="display-1">Planlagte</div>
        </v-row>
      </v-col>
    </v-row>
    <v-col>
      <v-row>
        <v-col>
          <v-row v-for="message in readyMsg" :key="message.id">
            <v-btn icon @click="deletePlannedMsg(message)" color="grey">
              <v-icon>mdi-delete</v-icon> </v-btn
            ><v-chip small
              >{{ message.date | moment("DD/MM/YY") }} kl.
              {{ message.date | moment("HH:mm") }}</v-chip
            >

            {{ message.json.message }}
          </v-row>
        </v-col>
      </v-row>
      <v-row v-if="oldMessages.length > 0" class="mt-3">
        <v-col>
          <v-row>
            <div class="subtitle-2">Overskredet</div>
          </v-row>

          <v-row v-for="message in oldMessages" :key="message.id">
            <v-btn @click="deletePlannedMsg(message)" icon color="grey">
              <v-icon>mdi-delete</v-icon> </v-btn
            ><v-chip small
              >{{ message.date | moment("DD/MM/YY") }} kl.
              {{ message.date | moment("HH:mm") }}</v-chip
            >

            {{ message.json.message }}
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
import Vue2Filters from "vue2-filters";
import * as firebase from "firebase/app";
import { db } from "../main";
import TestVue from "./Test.vue";
const moment = require("moment");

export default {
  mixins: [Vue2Filters.mixin],
  props: ["classData"],
  methods: {
    deletePlannedMsg(message) {
      // got o firebase and delete the id
      if (confirm("Er du sikker?")) {
        db.collection("scheduledSMS")
          .doc(message.id)
          .delete()
          .then(function() {
            console.log("Document successfully deleted!");
          })
          .catch(function(error) {
            console.error("Error removing document: ", error);
          });

        console.log("deleting ", message.id);
        this.messages.splice(this.messages.indexOf(message), 1);
        //this.getMsgs();
      } else {
        console.log("du trykkede annuller");
      }
    },
    getMsgs() {
      this.messages = [];
      //  .where("class", "==", `${this.classData.id}`)
      db.collection("scheduledSMS")

        .where("class", "==", `${this.classData.id}`)
        .where("sent", "==", false)

        //.orderBy("date")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            console.log(doc.id, " => ", doc.data());
            var data = doc.data();

            //data.json = JSON.parse(data.json);
            data.date = data.date.toDate();
            //data.date = new Date(data.date * 1000); // date object
            data.id = doc.id;

            this.messages.push(data);
          });
        })
        .catch(function(error) {
          console.log("Error getting documents: ", error);
        });
    },
  },
  computed: {
    oldMessages() {
      var expired = this.messages.filter(
        (message) => new Date(message.date) < new Date()
      );
      return expired;
    },
    readyMsg() {
      var valid = this.messages.filter(
        (message) => new Date(message.date) > new Date()
      );
      return valid;
    },
  },
  data() {
    return {
      messages: [],
    };
  },
  created() {
    this.getMsgs();
  },
};
</script>

<style lang="scss" scoped></style>
